import * as App from '../../app';
import { EndGameScreen } from '../../components';
export function endGameScreen(props) {
    var endGameScreen = new EndGameScreen({
        onClick: function (cancel) {
            var _a;
            if (cancel) {
                setTimeout(function () { return props.cancelScreen().show(); }, 200);
            }
            else {
                if ((FOR_YANDEX || FOR_VK) && App.settings.get().showNativeOnCloseModal) {
                    App.Fn.showNative(function () { return props.startGame(); });
                }
                else {
                    props.startGame();
                }
                App.sounds.clickButton();
            }
            App.stat.params({ buttons: { endGameScreen: (_a = {}, _a[cancel ? 'cancel' : 'newGame'] = 1, _a) } });
        },
    });
    return endGameScreen;
}
